const ERRORS = {
  INVALID_CALLBACK: 'Invalid callback.',
  INVALID_EVENT: 'Invalid event.',
  INVALID_DATA: 'Invalid data.',
  REQUEST_TIME_OUT: 'Request time error',
};

export default ERRORS;
